export default __webpack_public_path__ + "821091de0b0c2e7250c826c821d43b2c.svg";